<template>
	<Card :title="trans('enrollments.bundles.title')" :subtitle="trans('enrollments.bundles.subtitle')">
		<LabeledObject v-if="shoppingStage">
			<template #label>{{ trans('enrollments.bundles.selections.deadline') }}</template>
			<p>{{ dayjs(shoppingStage.ends_at).format(trans('general.dayjs.datetime')) }}</p>
		</LabeledObject>
		<template v-if="allowedToAddOffers">
			<Link :as="SecondaryButton" :color="Color.Green" class="place-self-start" :href="route('events.enrollments.bundles.offers.create', enrollment.id)">
				<i class="fa-solid fa-dollar-sign mr-2"/>
				{{ trans('enrollments.bundles.purchase') }}
			</Link>
			<List>
				<template v-for="bundle in bundles" :key="`bundle-${bundle.id}`">
					<ListItem
						v-if="totalOffersByBundle[bundle.id] > 0 && shoppingStageBundleIds.includes(bundle.id)"
						:title="bundle.title"
						:subtitle="trans('enrollments.bundles.selected_count', {selected: `${selectedOffersByBundle[bundle.id] ?? 0}`, total: `${totalOffersByBundle[bundle.id]}`})"
					>
						<p>{{ bundle.offer_list }}</p>
					</ListItem>
				</template>
			</List>
		</template>
		<p v-else class="text-gray-400 dark:text-gray-600">{{ trans('enrollments.bundles.selections.closed') }}</p>
	</Card>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import Card from '@/Components/Cards/Card.vue'
import List from '@/Components/Lists/List.vue'
import ListItem from '@/Components/Lists/ListItem.vue'
import {type Bundle} from '@/Types/Events/Bundles/Bundle'
import LabeledObject from '@/Components/LabeledObject.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'
import {type ShoppingStage} from '@/Types/Events/Stages/ShoppingStage'

const props = defineProps<{
	enrollment:Enrollment,
	allowedToAddOffers:boolean,
	shoppingStage:ShoppingStage,
	bundles:Array<Bundle>,
	totalOffersByBundle:Array<number>,
	shoppingStageBundleIds:Array<number>,
	selectedOffersByBundle:Array<number>,
}>()

const bundles:Ref<Array<Bundle>> = ref(props.bundles)
const enrollment:Ref<Enrollment> = ref(props.enrollment)
const shoppingStage:Ref<ShoppingStage> = ref(props.shoppingStage)
const allowedToAddOffers:Ref<boolean> = ref(props.allowedToAddOffers)
const totalOffersByBundle:Ref<Array<number>> = ref(props.totalOffersByBundle)
const shoppingStageBundleIds:Ref<Array<number>> = ref(props.shoppingStageBundleIds)
const selectedOffersByBundle:Ref<Array<number>> = ref(props.selectedOffersByBundle)
</script>